<template>
  <div class="about">

    <div class="banner">
      <div class="intro">
        <div class="intro-container container-width">
          <p class="intro-title">
            深圳市雁来信网络科技有限公司
          </p>
          <p >
            成立于2012年4月，是专注于社交通讯软件研发、运营的互联网科技企业，荣获“国家高新技术企业”、“福建省科技小巨人领军企业”、“2021年福建数字经济领域未来独角兽”多重认证。
            <br >
            企业旗下运营“心链交友”、“配配”以及海外事业，为我国适龄单身用户提供一站式社交、直播和泛娱乐服务，目前已覆盖用户2亿。海豹信息以关注用户、尊重用户、理解用户作为核心经营理念，把创造社会价值，赢得用户喜爱当做企业奋斗目标。
            <br >
            公司总部位于深圳，占地6000㎡，员工500人，并在深圳、武汉等地设立分部。
          </p>
        </div>
      </div>
    </div>

    <div class="intro-pie">
      <div class="pie-charts container-width">

        <div class="pie-info">
          <p class="pie-info-title">
            真人社交
          </p>
          <p class="pie-info-content">
            信息互动为中心的社交板块。在传统社交的基础上新增了真人认证、颜值匹配、一键搭讪、附近的人等多种交互功能，进一步拓展用户联系，围绕用户兴趣开展交互式功能的探索，以满足在线用户的交友需求。
          </p>
        </div>

        <div class="pie-info">
          <p class="pie-info-title">
            互动直播
          </p>
          <p class="pie-info-content">
            高颜值主播聚集地，累计3万+主播入驻，素人角色扮演、惊喜高能才艺，全新PK玩法、排位赛模式在线实时互动，为用户带来不一样的视听体验
          </p>
        </div>

        <div class="pie-info">
          <p class="pie-info-title">
            兴趣广场
          </p>
          <p class="pie-info-content">
            以UGC为中心的内容分享板块。运营了六大类约20个创意主题圈，超过95%的内容为用户自发创作，主题涵盖交友、兴趣分享、情感沟通、产品体验交流等多类话题。
          </p>
        </div>

      </div>
    </div>
    <div class="milestone">
      <div class="milestone-container container-width">
        <p class="milestone-title">
          品牌里程
        </p>
        <div class="milestone-wrap">
          <div class="milestone-list">
            <div class="milestone-box">
              <div class="swiper-container swiper-container-initialized swiper-container-vertical">
                <div class="swiper-wrapper" style="transition-duration: 0ms; transform: translate3d(0px, -176px, 0px);">
                  <div class="swiper-slide" style="height: 88px;">
                    <div class="milestone-item">
                      <p class="milestone-time">
                        2020年10月
                      </p>
                      <div class="milestone-detail">
                        <p >
                          心链交友用户总量突破1亿
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide swiper-slide-prev" style="height: 88px;">
                    <div class="milestone-item">
                      <p class="milestone-time">
                        2020年4月
                      </p>
                      <div class="milestone-detail">
                        <p >
                          心链交友功能改版，全面进军社交领域
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide swiper-slide-active" style="height: 88px;">
                    <div class="milestone-item">
                      <p class="milestone-time">
                        2019年8月
                      </p>
                      <div class="milestone-detail">
                        <p >
                          心链交友发起“街潮崛起计划”，正式进军潮牌
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide swiper-slide-next" style="height: 88px;">
                    <div class="milestone-item">
                      <p class="milestone-time">
                        2018年5月
                      </p>
                      <div class="milestone-detail">
                        <p >
                          心链交友正式进军泛娱乐，并推出全新品牌slogan——“無樂不做”
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide" style="height: 88px;">
                    <div class="milestone-item">
                      <p class="milestone-time">
                        2016年8月
                      </p>
                      <div class="milestone-detail">
                        <p >
                          心链交友直播上线
                        </p>
                      </div>
                    </div>
                  </div>
                  <!--<div class="swiper-slide" style="height: 88px;">-->
                    <!--<div class="milestone-item">-->
                      <!--<p class="milestone-time">-->
                        <!--2016年5月-->
                      <!--</p>-->
                      <!--<div class="milestone-detail">-->
                        <!--<p >-->
                          <!--深圳心链信息技术股份有限公司在新三板挂牌公开转让并进入创新层，获得东方证券、安信证券、兴业证券、中信建投、九州证券、爱建证券等多家定增，证券简称他趣股份，代码837472，估值6.5亿元人民币-->
                        <!--</p>-->
                      <!--</div>-->
                    <!--</div>-->
                  <!--</div>-->
                  <!--<div class="swiper-slide" style="height: 88px;">-->
                    <!--<div class="milestone-item">-->
                      <!--<p class="milestone-time">-->
                        <!--2015年10月-->
                      <!--</p>-->
                      <!--<div class="milestone-detail">-->
                        <!--<p >-->
                          <!--公司完成股改，名称由“厦门海豹信息技术有限公司”变更为“厦门海豹信息技术股份有限公司”，拟登录新三板-->
                        <!--</p>-->
                      <!--</div>-->
                    <!--</div>-->
                  <!--</div>-->
                  <!--<div class="swiper-slide" style="height: 88px;">-->
                    <!--<div class="milestone-item">-->
                      <!--<p class="milestone-time">-->
                        <!--2015年8月-->
                      <!--</p>-->
                      <!--<div class="milestone-detail">-->
                        <!--<p >-->
                          <!--获得中信建投，鼎峰资产，达晨创投以及高晟融信的8000万B轮融资，估值3.5亿人民币-->
                        <!--</p>-->
                      <!--</div>-->
                    <!--</div>-->
                  <!--</div>-->
                  <!--<div class="swiper-slide" style="height: 88px;">-->
                    <!--<div class="milestone-item">-->
                      <!--<p class="milestone-time">-->
                        <!--2014年9月-->
                      <!--</p>-->
                      <!--<div class="milestone-detail">-->
                        <!--<p >-->
                          <!--性价比APP获得达晨创投2000+万A轮融资，并且全面更名为心链交友APP-->
                        <!--</p>-->
                      <!--</div>-->
                    <!--</div>-->
                  <!--</div>-->
                  <!--<div class="swiper-slide" style="height: 88px;">-->
                    <!--<div class="milestone-item">-->
                      <!--<p class="milestone-time">-->
                        <!--2013年6月-->
                      <!--</p>-->
                      <!--<div class="milestone-detail">-->
                        <!--<p >-->
                          <!--天使轮首轮融资成功-->
                        <!--</p>-->
                      <!--</div>-->
                    <!--</div>-->
                  <!--</div>-->
                  <div class="swiper-slide" style="height: 88px;">
                    <div class="milestone-item">
                      <p class="milestone-time">
                        2012年7月
                      </p>
                      <div class="milestone-detail">
                        <p >
                          心链交友APP正式上线
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide" style="height: 88px;">
                    <div class="milestone-item">
                      <p class="milestone-time">
                        2012年4月
                      </p>
                      <div class="milestone-detail">
                        <p >
                          深圳市雁来信网络科技有限公司成立
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <span class="swiper-notification" aria-live="assertive" aria-atomic="true">
									</span>
              </div>
            </div>
          </div>
          <div slot="button-prev" class="swiper-button-prev"
               tabindex="0" role="button" aria-label="Previous slide" aria-disabled="false">
          </div>
          <div slot="button-next" class="swiper-button-next"
               tabindex="0" role="button" aria-label="Next slide" aria-disabled="false">
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>

  export default {
    data () {
      return {
      }
    },
    methods:{

    },
    mounted(){
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  .echarts {
    width:600px;
    height:400px
  }
  .pie .echarts {
    width:100%;
    height:100%
  }
  .pie-charts {
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-pack:justify;
    -ms-flex-pack:justify;
    justify-content:space-between
  }
  .pie-box {
    width:639px;
    height:639px;
    background:url(../../assets/img/609_circle_blue.1bb985e9.png) no-repeat;
    position:relative
  }
  .pie,.pie-box {
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-pack:center;
    -ms-flex-pack:center;
    justify-content:center;
    -webkit-box-align:center;
    -ms-flex-align:center;
    align-items:center
  }
  .pie {
    width:600px;
    height:600px;
    overflow:hidden
  }
  .pie-info {
    width:420px;
    padding-top:10px;
    padding-left:30px
  }
  .pie-info-title {
    font-size:36px;
    line-height:72px
  }
  .pie-info-content {
    font-size:14px;
    line-height:24px
  }
  .pie-icon {
    padding-top:20px
  }
  .pie-centre {
    width:280px;
    height:280px;
    border-radius:50%;
    overflow:hidden;
    position:absolute;
    top:180px;
    left:180px;
    background:#fff;
    z-index:2;
    -webkit-box-shadow:0 0 51px 8px rgba(38,50,235,.26);
    box-shadow:0 0 51px 8px rgba(38,50,235,.26);
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-pack:center;
    -ms-flex-pack:center;
    justify-content:center;
    -webkit-box-align:center;
    -ms-flex-align:center;
    align-items:center
  }
  .pie-core {
    background:url(../../assets/img/279_circle_red.487d05bc.png) no-repeat;
    width:260px;
    height:260px;
    position:absolute;
    top:10px;
    left:10px;
    -webkit-animation:rotationCore 24s linear infinite;
    animation:rotationCore 24s linear infinite
  }
  .pie-touch {
    background:#fff url(data:image/png;base64,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) 50% 50% no-repeat;
    width:132px;
    height:42px;
    position:relative;
    z-index:2
  }
  .pie-circle {
    width:639px;
    height:639px;
    position:absolute;
    top:0;
    left:0;
    -webkit-animation:rotation 36s linear infinite;
    animation:rotation 36s linear infinite;
    background:url(data:image/png;base64,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) no-repeat
  }
  @-webkit-keyframes rotation {
    0% {
      -webkit-transform:rotate(0deg);
      transform:rotate(0deg)
    }
    to {
      -webkit-transform:rotate(-1turn);
      transform:rotate(-1turn)
    }
  }
  @keyframes rotation {
     0% {
       -webkit-transform:rotate(0deg);
       transform:rotate(0deg)
     }
     to {
       -webkit-transform:rotate(-1turn);
       transform:rotate(-1turn)
     }
  }
  @-webkit-keyframes rotationCore {
      0% {
        -webkit-transform:rotate(0deg);
        transform:rotate(0deg)
      }
      to {
        -webkit-transform:rotate(1turn);
        transform:rotate(1turn)
      }
    }
  @keyframes rotationCore {
       0% {
         -webkit-transform:rotate(0deg);
         transform:rotate(0deg)
       }
       to {
         -webkit-transform:rotate(1turn);
         transform:rotate(1turn)
       }
  }
  .banner {
        height:419px;
        background:url(../../assets/img/blur_bg@2x.9499c037.jpg) 50% 50% no-repeat;
        background-size:cover
      }
  .intro-container {
    height:388px;
    font-size:14px;
    color:#fff;
    line-height:24px;
    padding-top:188px;
    -webkit-box-pack:center;
    -ms-flex-pack:center;
    justify-content:center
  }
  .intro-title {
    font-size:32px;
    font-weight:700;
    line-height:72px
  }
  .intro-pie {
    padding:20px 0 40px 0
  }
  .milestone {
    padding-top:20px;
    padding-bottom:120px
  }
  .milestone-title {
    font-size:17px;
    line-height:90px
  }
  .milestone-list {
    height:382px;
    overflow:hidden;
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-orient:vertical;
    -webkit-box-direction:normal;
    -ms-flex-flow:column;
    flex-flow:column;
    -webkit-box-pack:center;
    -ms-flex-pack:center;
    justify-content:center;
    background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbBAMAAAB/+ulmAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExUReO9WEdwTOK9Weq/auO9WOW/WOG9WOS/WOW+WOO8WuK8WOG7WufBXOW+WeS/WFDZlnYAAAAOdFJOU2UANAZd83Hgu0FRIiGLdtSq2AAAAKJJREFUGNNjEAQC61kOXrMNgQwBBiBhxAACTIYQrowDmMvgA+EqMECBIogrBOMxMIG4B+BchoMCDMIOCK6zAANCLVC1AIMBiM4orUgA0QYMG4Akb9y7d7Eg7gaGCUAy9d27d09B0hMYFgDJPiD3XQOQsYABZHAdiFsAZEBsiQNxA8BMNFk0vWgmo9mL5io0N6P5CM2/6KGBFlboIYkWzsixAADMfkF1FZhgeAAAAABJRU5ErkJggg==) 0 50% no-repeat;
    margin-left:-41px
  }
  .milestone-container::-moz-selection {
    background:none
  }
  .milestone-container::selection {
    background:none
  }
  .milestone-wrap {
    border-left:1px solid #f1f1f1;
    padding-left:27px;
    position:relative;
    margin-left:6px
  }
  .swiper-slide {
    height:88px;
    font-size:14px;
    color:#737373;
    line-height:25px
  }
  .milestone-item {
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    min-height:88px
  }
  .milestone-detail {
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-orient:vertical;
    -webkit-box-direction:normal;
    -ms-flex-flow:column;
    flex-flow:column;
    -webkit-box-pack:center;
    -ms-flex-pack:center;
    justify-content:center;
    padding-left:70px
  }
  .milestone-time {
    font-size:17px;
    color:#353535;
    line-height:88px;
    width:150px;
    text-align:right;
    -ms-flex-negative:0;
    flex-shrink:0
  }
  .swiper-slide-active .milestone-time {
    font-size:24px;
    color:#e4bf58
  }
  .milestone-box {background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA5QAAAACCAMAAAAQP2O5AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABdUExUReS/WeS/WOS/WOS/WOS/WOS/WOS/WOO/WeS/WOS/WOS/V+S/WOS/WOXBXOS/WOS/WeS/WOTAWuTAWujCYuS/WOS/WOXAWOS/WuS/WOS/WOS/WOS/WOzTZuS/WOS/WFu+17sAAAAfdFJOUx8kdkhcP1MaaG1YQ34JNyhxERUFM0wsDXpgZDsCME+Wkl+IAAABSUlEQVR42n3T25aCMAxA0XIXUO6gIvL/nzlJ07RpcM0+ad5dEnMEs/CIPCOjNE0wQTVVF0ZLlF7a+k36CovQSZ9YEWmLVsliq3AKpdKUTSRX3sEeuym1MsTSIY29vPv/XkJ6MSi1dlN25S3lSqOUF6ewCpnWZq1UXHyUTli6RfqyTemVJGIwrfphEkYY6ak8pFk5PGP4Ig9xkdAcLhKC7YwUm3DERdKSF0mxxIaL9ZSzwYSz/EKwyYKRDsJlfSBcTgE3iYu0GAzLMFpo5ci5houkvAaDYTnlvDFvty+cJOXUcJK0yQDhYilHXpxzx/l5jxRL7Qv3GCI15904tlMMfhIOySnWQLi8knNODIdP8oRIBoMR9wfBZoUbvkfO6TBvsXV8kOIkYTDWw2AkgXAxg2PkYVY2XF743j17EewJgxF7RrjIjA9zDuEP5CdldI1m+/oAAAAASUVORK5CYII=) 50% top no-repeat;
    overflow:visible;
    padding-left:40px
  }
  .swiper-container {
    height:88px;
    background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA5QAAAACCAMAAAAQP2O5AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABdUExUReS/WeS/WOS/WOS/WOS/WOS/WOS/WOO/WeS/WOS/WOS/V+S/WOS/WOXBXOS/WOS/WeS/WOTAWuTAWujCYuS/WOS/WOXAWOS/WuS/WOS/WOS/WOS/WOzTZuS/WOS/WFu+17sAAAAfdFJOUx8kdkhcP1MaaG1YQ34JNyhxERUFM0wsDXpgZDsCME+Wkl+IAAABSUlEQVR42n3T25aCMAxA0XIXUO6gIvL/nzlJ07RpcM0+ad5dEnMEs/CIPCOjNE0wQTVVF0ZLlF7a+k36CovQSZ9YEWmLVsliq3AKpdKUTSRX3sEeuym1MsTSIY29vPv/XkJ6MSi1dlN25S3lSqOUF6ewCpnWZq1UXHyUTli6RfqyTemVJGIwrfphEkYY6ak8pFk5PGP4Ig9xkdAcLhKC7YwUm3DERdKSF0mxxIaL9ZSzwYSz/EKwyYKRDsJlfSBcTgE3iYu0GAzLMFpo5ci5houkvAaDYTnlvDFvty+cJOXUcJK0yQDhYilHXpxzx/l5jxRL7Qv3GCI15904tlMMfhIOySnWQLi8knNODIdP8oRIBoMR9wfBZoUbvkfO6TBvsXV8kOIkYTDWw2AkgXAxg2PkYVY2XF743j17EewJgxF7RrjIjA9zDuEP5CdldI1m+/oAAAAASUVORK5CYII=) 50% bottom no-repeat;
    cursor:pointer;
    overflow:visible
  }
  .swiper-button-prev {
    background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFKADAAQAAAABAAAAFQAAAACPvdlNAAAAt0lEQVQ4EWNgGAWDLgQYCbno/5k01qdfP0eB1Elz8y5jNJn1G58evAa+2p/F85vx/fb////bgAxhZGQ8wvpf0FPMcdoXXIbiNBDdMJgBhAzFaiAuw4gxFMNAQoYRMhTFQGINw2co3EBSDcNlKBNIApQ0kGMTppgYGpQCwHqBZoDUgw0EpTNY0iDGEHQ1IL2wtAo2EF0BJXywgdIi6suB6WsVAyPDL5INA+oB6QXlIpL1jmqgTwgAAG6Uchi7OWcbAAAAAElFTkSuQmCC) 50% 50% no-repeat;
    background-size:contain;
    width:22px;
    height:22px;
    position:absolute;
    top:106px;
    left:-12px;
    outline:0;
    cursor:pointer
  }
  .swiper-button-next {
    background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFKADAAQAAAABAAAAFQAAAACPvdlNAAAA40lEQVQ4EWNgGAWDLgQYQS76/7+B6fnBm93//v/3Z2BkZCfJlf///2RiYNwg6bCslJGR8T/YwCcHokIZ/v9bRZJB6IoZmcJkHJatZgKJMzH+F0KXJ5UPMwNsIMs/waVA514j1RCYepBeJgGWJSA+2EAxx2lfWDgYnMgxFKQHpFdCf/FXkIHgMAQxQODliUjxPz8Y9v3//18LIoKfhBkmbrH8JUwlioEgQWINxWYYSD+GgcQYisswnAbiMxSfYXgNxGYoIcMIGghS8O5MGv+3z59yQWwuXr7JQiazPoLYo2AIhQAAGGRhaR49ZM0AAAAASUVORK5CYII=) 50% 50% no-repeat;
    background-size:contain;
    width:22px;
    height:22px;
    position:absolute;
    top:255px;
    left:-12px;
    outline:0;
    cursor:pointer
  }
  .swiper-button-prev.swiper-button-disabled {
    background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFKADAAQAAAABAAAAFQAAAACPvdlNAAAAuklEQVQ4EWNgGAWDLgQYCbno////rD9+/IgCqePg4FjGyMj4m5AenPJAw3i+f/9++Nu3b/9BGMQGieHUgE8C3TBiDcXqZZBhQG9uB9I22CwFevsI0PueQPoLujyGgYQMgxmAy1AUA4k1DJ+hcANJNQyXoWADgYaBksY+II01zGCacdFQ7zsB6d9MIEWgdEauYSD9IL2wtAo2ECRILQA2EJgElgOduwqIf5FqMEgPSC8oF5Gqd1Q9nUIAAJzbh947NkaqAAAAAElFTkSuQmCC);
    cursor:default
  }
  .swiper-button-next.swiper-button-disabled {
    background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFKADAAQAAAABAAAAFQAAAACPvdlNAAAA20lEQVQ4EWNgGAWDLgQYQS76//8/08+fP7uBtD8Qs5PiSkZGxp9AvIGdnb0USP8HG/jt27dQoCGrSDEIi9owLi6u1UwgCSYmJiEsCkgSgpkB8zLPjx8/TgK9q0WSKVDFQK9e4+DgMAPSX8EuBDK+AAWcQBKkGgg1DKT3K0gv2IUwQ4AuFAe6dB+xLkUy7CXMDBQDQYLEGorNMJB+DAOJMRSXYSC9OAHIpd+/f78KTFL/kTFIDCSHUyM+CXRDiTEMq5eRLQEayg+MqFyQGDAlTAZ69yOy/Ch7CIQAAK8nhA8y7idXAAAAAElFTkSuQmCC);
    cursor:default
  }

  .container-width {
    width:1060px;
    margin:0 auto
  }



</style>



// WEBPACK FOOTER //
// src/views/About.vue